import * as types from './type';


const initialState = {
    detail: '',
    featuredResProjects: '',
    featuredCommProjects: '',
    projectListObject: '',
    projectTypes: ''
};



export default function projectReducer(state = initialState, action) {

  switch (action.type) {
      
    case types.GET_PROJECT_DETAIL: {
      if (action.payload && action.payload.data) {
       
        return {
          ...state,
          detail: action.payload.data
        }
      } else {
        return {
          ...state
        }
      }
    }
    case types.GET_PROJECT_TYPES: {
      
      if (action.payload && action.payload.data) {
       
        return {
          ...state,
          projectTypes: action.payload.data
        }
      } else {
        return {
          ...state
        }
      }
    }
    case types.GET_PROJECTS_WITH_PAGINATION: {
      
      if (action.payload && action.payload.data) {
        return {
          ...state,
          projectListObject: action.payload.data
        }
      } else {
        return {
          ...state
        }
      }
    }
    case types.GET_RES_FEATURED_PROJECTS: {
      
      if (action.payload && action.payload.data) {
       
        return {
          ...state,
          featuredResProjects: action.payload.data
        }
      } else {
        return {
          ...state
        }
      }
    }
    case types.GET_COMM_FEATURED_PROJECTS: {
      
      if (action.payload && action.payload.data) {
       
        return {
          ...state,
          featuredCommProjects: action.payload.data
        }
      } else {
        return {
          ...state
        }
      }
    }
    case types.GET_FEATURED_PROJECTS_WITH_PAGINATION: {
      
      if (action.payload && action.payload.data) {
       
        return {
          ...state,
          featuredPropertiesObj: action.payload.data
        }
      } else {
        return {
          ...state
        }
      }
    }
    default: {
      return {
        ...state
      };
    }
    
  }

}